import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class DataCustomerInfoApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'dataCustomerInfo'
  }


  /**
   * 客户登记变动
   */
  public update(){
    return this.send({},"update",this.Methods.GET)
  }

}